import React from "react";
import Styled from "./index.style";

const ImageCommon = ({ ...restProps }) => {
  return <Styled {...restProps}></Styled>;
};
export default ImageCommon;
